import { createElementBlock as t, openBlock as n, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return n(), t("svg", l, e[0] || (e[0] = [
    o("path", {
      fill: "#000",
      d: "M18.857 23.034c-1.302 1.263-2.738 1.066-4.107.47-1.456-.607-2.786-.646-4.323 0-1.915.826-2.93.586-4.084-.47C-.166 16.331.795 6.124 8.193 5.74c1.794.096 3.05.992 4.107 1.067 1.57-.32 3.074-1.235 4.755-1.115q3.028.245 4.54 2.395c-4.155 2.498-3.17 7.974.646 9.511-.764 2.006-1.744 3.987-3.386 5.452zM12.156 5.668C11.96 2.69 14.376.24 17.152 0c.381 3.435-3.123 6.005-4.996 5.668"
    }, null, -1)
  ]));
}
const i = { render: r };
export {
  i as default,
  r as render
};
//# sourceMappingURL=ic_brand_apple-BBJIS2Xh.js.map
